import { put, call, takeEvery, all } from 'redux-saga/effects'

import { FETCH_EXCLUSION_FILES, FETCH_EXCLUSION_FILE, ADD_EXCLUSION_FILE, UPDATE_EXCLUSION_FILE, REMOVE_EXCLUSION_FILE } from '../actions/types'
import {
  fetchExclusionFilesSuccess,
  fetchExclusionFilesFailure,
  fetchExclusionFileSuccess,
  fetchExclusionFileFailure,
  addExclusionFileSuccess,
  addExclusionFileFailure,
  updateExclusionFileSuccess,
  updateExclusionFileFailure,
  removeExclusionFileSuccess,
  removeExclusionFileFailure,
  fetchExclusionFiles,
} from '../actions/exclusionsActions'
import exclusionsService from '../services/exclusionsService'

function* handleFetchFiles(action) {
  try {
    const { accessToken } = action.payload
    const files = yield call(exclusionsService.fetchFiles, accessToken)
    yield put(fetchExclusionFilesSuccess(files))
  } catch (err) {
    console.error(err, 'Error fetching exclusion files')
    yield put(fetchExclusionFilesFailure(err))
  }
}

function* handleFetchFile(action) {
  const { fileName, accessToken } = action.payload

  try {
    const content = yield call(exclusionsService.fetchFile, accessToken, fileName)
    yield put(fetchExclusionFileSuccess(fileName, content))
  } catch (err) {
    console.error(err, `Error fetching file ${fileName}`)
    yield put(fetchExclusionFileFailure(fileName, err))
  }
}

function* handleAddFile(action) {
  const { fileName, content, accessToken } = action.payload

  try {
    yield call(exclusionsService.addFile, accessToken, fileName, content)
    yield put(addExclusionFileSuccess(fileName))
    yield put(fetchExclusionFiles(accessToken))
  } catch (err) {
    console.error(err, `Error adding file ${fileName}`)
    yield put(addExclusionFileFailure(fileName, err))
  }
}

function* handleUpdateFile(action) {
  const { fileName, content, accessToken } = action.payload

  try {
    yield call(exclusionsService.updateFile, accessToken, fileName, content)
    yield put(updateExclusionFileSuccess(fileName))
    yield put(fetchExclusionFiles(accessToken))
  } catch (err) {
    console.error(err, `Error updating file ${fileName}`)
    yield put(updateExclusionFileFailure(fileName, err))
  }
}

function* handleRemoveFile(action) {
  const { fileName, accessToken } = action.payload

  try {
    yield call(exclusionsService.removeFile, accessToken, fileName)
    yield put(removeExclusionFileSuccess(fileName))
    yield put(fetchExclusionFiles(accessToken))
  } catch (err) {
    console.error(err, `Error removing file ${fileName}`)
    yield put(removeExclusionFileFailure(fileName, err))
  }
}

function* watchExclusionsSagas() {
  yield all([
    takeEvery(FETCH_EXCLUSION_FILES, handleFetchFiles),
    takeEvery(FETCH_EXCLUSION_FILE, handleFetchFile),
    takeEvery(ADD_EXCLUSION_FILE, handleAddFile),
    takeEvery(UPDATE_EXCLUSION_FILE, handleUpdateFile),
    takeEvery(REMOVE_EXCLUSION_FILE, handleRemoveFile),
  ])
}

export default watchExclusionsSagas
